"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.validation = exports.initialValues = exports.getPaymentIntent = exports.confirmCardPayment = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reactStripeJs = require("@stripe/react-stripe-js");

var _axios = _interopRequireDefault(require("axios"));

var _yup = require("yup");

var validation = (0, _yup.object)().shape({
  cardholderName: (0, _yup.string)("Please enter the name on the card").required("A cardholder name is required"),
  emailAddress: (0, _yup.string)("Please enter your email address").email("Please enter a valid email address").required("An email address is required"),
  addressFirstLine: (0, _yup.string)("Please enter your address").required("An address is required"),
  companyName: (0, _yup.string)(),
  postcode: (0, _yup.string)("Please enter your postal code").required("A valid postal code is required"),
  city: (0, _yup.string)("Please enter your town or city").required("A valid town or city is required"),
  country: (0, _yup.string)().required()
});
exports.validation = validation;
var initialValues = {
  cardholderName: "",
  emailAddress: "",
  companyName: "",
  addressFirstLine: "",
  postcode: "",
  city: "",
  country: "GB"
};
exports.initialValues = initialValues;

var getPaymentIntent = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(apiQuery, e) {
    var _data$data, _data$data2;

    var paymentIntentQuery, _yield$axios, data;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            paymentIntentQuery = (0, _extends2["default"])({}, apiQuery, {
              data: (0, _extends2["default"])({}, apiQuery.data, {
                variables: (0, _extends2["default"])({}, apiQuery.data.variables, e)
              })
            });
            _context.next = 3;
            return (0, _axios["default"])(paymentIntentQuery);

          case 3:
            _yield$axios = _context.sent;
            data = _yield$axios.data;
            return _context.abrupt("return", (data == null ? void 0 : (_data$data = data.data) == null ? void 0 : _data$data.purchaseAwardsLicence) || (data == null ? void 0 : (_data$data2 = data.data) == null ? void 0 : _data$data2.handlePayment));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getPaymentIntent(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.getPaymentIntent = getPaymentIntent;

var confirmCardPayment = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2, stripe, paymentIntent, elements) {
    var cardholderName, city, country, addressFirstLine, companyName, postCode;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cardholderName = _ref2.cardholderName, city = _ref2.city, country = _ref2.country, addressFirstLine = _ref2.addressFirstLine, companyName = _ref2.companyName, postCode = _ref2.postCode;
            return _context2.abrupt("return", stripe.confirmCardPayment(paymentIntent, {
              payment_method: {
                card: elements.getElement(_reactStripeJs.CardElement),
                billing_details: {
                  name: cardholderName,
                  address: {
                    city: city,
                    country: country,
                    line1: addressFirstLine,
                    line2: companyName,
                    postal_code: postCode
                  }
                }
              }
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function confirmCardPayment(_x3, _x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

exports.confirmCardPayment = confirmCardPayment;